import { ROLES } from "./actionTypes";

const INIT_STATE = {
  userRoles: null,
  loadingRoles: true
};

const RolesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ROLES.GET_ITEM.REQUEST:
      state = {
        ...state,
        loadingRoles: true
      };
      break;
    case ROLES.GET_ITEM.SUCCESS:
      state = {
        ...state,
        userRoles: action.payload,
        loadingRoles: false
      };
      break;
    case ROLES.GET_ITEM.FAIL:
      state = {
        ...state,
        userRoles: null,
        loadingRoles: false
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RolesReducer;
